import { Modal } from "react-bootstrap";
import styled from "styled-components";

export const ModalContent = styled.div`
  font-size: 16px;

  h2 {
    font-size: 16px;
  }

  ol,
  ul {
    margin-left: 24px;
  }
`;

export const ModalFooter = styled(Modal.Footer)`
  justify-content: inherit;

  form {
    width: 100%;

    button:last-child {
      margin: 16px auto;
    }
  }
`;

export const LocationDate = styled.p`
  margin-top: 16px;
  font-size: small;
  font-style: italic;
  color: #92959e;
`;
